import PropTypes from 'prop-types';
import React from 'react';

import styles from './BriefRow.module.scss';
import TopicBand from './TopicBand';

const BriefRow = ({
  label,
  tone = 'default',
  meta,
  flush = false,
  collapsible = false,
  id,
  className,
  children,
}) => {
  const [open, setOpen] = React.useState(false);
  const expanded = !collapsible || open;

  return (
    <section
      id={id}
      aria-label={label}
      className={[styles.card, styles[tone], className].filter(Boolean).join(' ')}
    >
      <TopicBand
        label={label}
        tone={tone}
        meta={meta}
        headingLevel="h3"
        expanded={expanded}
        onToggle={collapsible ? () => setOpen((value) => !value) : undefined}
      />
      {expanded && (
        <div className={`${styles.body} ${flush ? styles.flush : styles.padded}`}>{children}</div>
      )}
    </section>
  );
};

BriefRow.propTypes = {
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['default', 'alert', 'current', 'done', 'warn']),
  meta: PropTypes.node,
  flush: PropTypes.bool,
  collapsible: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default BriefRow;
